import UserVerifiedDocumentInterface from 'app/interfaces/UserVerifiedDocumentInterface';

export const disabledButton =
    (user_verified_documents: UserVerifiedDocumentInterface[]): boolean => user_verified_documents.length >= 1;
